module.exports = __webpack_public_path__ + "img/9manat-line-logo-01.9728ef72.png";